import { useSelector } from "react-redux";
import Spinner from "../../../lib/spinner";
import isEmpty from "lodash/isEmpty";
import sortBy from "lodash/sortBy";
import { Link } from "react-router-dom";
import Table from "../../../lib/tables";
import React from "react";
import {
  DaysToRespondProgress,
  DaysToUploadProgress,
} from "../../campaigns/days_to_respond_progress";
import ExclusiveTag from "../../../lib/exclusive_tag";
import ImpressionsProgress from "../../campaigns/impressions_progress";
import * as moment from "moment";

const itemStateToFriendlyName = {
  completed: "Complete",
  running: "In Progress",
  accepted: "Not Started",
};
/*
  Styles used for the tables on this page
  probably can refactor later to make it cleaner across all tables in the app
 */
const additionalStyle = () => ({
  style: { overflow: "visible" },
});
const tBodyAdditionalStyle = () => ({ style: { overflow: "visible", minHeight: "64px" } });
const tdAdditionalStyle = () => ({
  style: {
    overflow: "visible",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
});

const ShowAdvertisingPageTable = ({ title, sortedItems, columnInfo }) => (
  <>
    <h2 className={"m-bxs m-tm"}>{title}</h2>
    <Table
      getTdProps={tdAdditionalStyle}
      getTbodyProps={tBodyAdditionalStyle}
      getTableProps={additionalStyle}
      getTheadProps={() => ({
        style: {
          display: "none",
        },
      })}
      data={sortedItems}
      columns={columnInfo}
      addTopLine
    />
  </>
);
export const AwaitingAudioUploadTable = props => {
  const { campaignItems, showUUID } = props;
  const isLoading = useSelector(state => state.campaignItems.isLoading);

  if (isLoading) {
    return (
      <div className="position-relative" style={{ height: "100px" }}>
        <Spinner isLoading={isLoading} />
      </div>
    );
  }

  if (isEmpty(campaignItems)) {
    return null;
  }

  const sortedItems = sortBy(campaignItems, item => {
    // set timestamp to super old date (ex. 0) if respondByAt is not found.
    return item?.respondByAt ?? 0;
  });

  const columnInfo = [
    {
      accessor: "uuid",
      Cell: data => {
        const campaignItem = data.original;

        return (
          <div className="flex-row-container align-center">
            <CampaignNameTableColumn campaignItem={campaignItem} />
            <div className="flex-1" />

            <DaysToUploadProgress
              textFn={(daysLeft, clockTimeLocal) => {
                if (daysLeft > 1) {
                  return `Upload audio in ${daysLeft} days`;
                } else if (daysLeft === 1) {
                  return `Upload audio in 1 day`;
                }
                return `Upload audio by ${clockTimeLocal}`;
              }}
              campaignItem={campaignItem}
            />
            <Link
              to={`/shows/${showUUID}/campaigns/${campaignItem.campaignUUID}`}
              className="btn-link bold pointer margin-left--small">
              Upload Audio
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <ShowAdvertisingPageTable
      title={"Awaiting Audio Upload"}
      sortedItems={sortedItems}
      columnInfo={columnInfo}
    />
  );
};
export const SentCampaignsTable = props => {
  const { campaignItems, showUUID } = props;

  const isLoading = useSelector(state => state.campaignItems.isLoading);

  if (isLoading) {
    return (
      <div className="position-relative" style={{ height: "100px" }}>
        <Spinner isLoading={isLoading} />
      </div>
    );
  }

  const sortedItems = sortBy(campaignItems, item => {
    // set timestamp to super old date (ex. 0) if respondByAt is not found.
    return item?.respondByAt ?? 0;
  });
  if (isEmpty(campaignItems)) {
    return null;
  }

  const columnInfo = [
    {
      accessor: "uuid",
      Cell: data => {
        const campaignItem = data.original;

        return (
          <div className="flex-row-container align-center">
            <CampaignNameTableColumn campaignItem={campaignItem} />

            <div className="flex-1" />
            <DaysToRespondProgress
              textFn={(daysLeft, clockTimeLocal) => {
                if (daysLeft > 1) {
                  return `Respond in ${daysLeft} days`;
                } else if (daysLeft === 1) {
                  return `Respond in 1 day`;
                }
                return `Respond by ${clockTimeLocal}`;
              }}
              campaignItem={campaignItem}
            />
            <Link
              to={`/shows/${showUUID}/campaigns/${campaignItem.campaignUUID}`}
              className="btn-link bold pointer margin-left--small">
              Respond
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <ShowAdvertisingPageTable
      title={"Pending Invites"}
      sortedItems={sortedItems}
      columnInfo={columnInfo}
    />
  );
};
const CampaignNameTableColumn = ({ campaignItem }) => (
  <div className="flex-column-container margin-top--medium" style={{ overflow: "hidden" }}>
    <span
      className="bold"
      style={{ lineHeight: "20px", overflow: "hidden", textOverflow: "ellipsis" }}>
      {campaignItem.campaignName}
    </span>
    <span className="margin-bottom--medium" style={{ lineHeight: "24px" }}>
      Starting {moment.unix(campaignItem.startAt).format("LL")}
    </span>
  </div>
);
export const AcceptedCampaignsTable = props => {
  const { campaignItems, showUUID, history } = props;

  const isLoading = useSelector(state => state.campaignItems.isLoading);
  if (isEmpty(campaignItems) || isLoading) {
    return null;
  }

  campaignItems.sort(item => item.createdAt);

  const columnInfo = [
    {
      accessor: "uuid",
      Cell: data => {
        const campaignItem = data.original;

        return (
          <div className="flex-row-container align-center">
            <CampaignNameTableColumn campaignItem={campaignItem} />
            <div className="flex-1" />
            <div className={"m-rxxs"}>
              <ExclusiveTag>{itemStateToFriendlyName[campaignItem.state]}</ExclusiveTag>
            </div>
            <ImpressionsProgress className="margin-right--small" campaignItem={campaignItem} />
            <div
              className="btn-link bold pointer"
              onClick={() => {
                history.push(`/shows/${showUUID}/campaigns/${campaignItem.campaignUUID}`);
              }}>
              View
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <ShowAdvertisingPageTable
      title={"Accepted Ads"}
      sortedItems={campaignItems}
      columnInfo={columnInfo}
    />
  );
};
